<template>
  <div>
    <div class="mdgridviewpage-bg homenewbgdata">
      <training-header></training-header>
      <div class="container-fluid m-t-10px">
        <div class="row dashboardchart-container globalconfigcontainer">
          <div class="col-xs-12 col-sm-7 d-block d-sm-block d-md-none m-auto">
            <img src="../assets/img/info_pic.png" class="img-fluid" style />
          </div>
          <div class="col-lg-7 col-sm-7 col-xs-12 formDiv" style>
            <div class="card m-b-20px m-t-20px cardDiv">
              <div class="collapse show" aria-labelledby="headingOne">
                <ValidationObserver v-slot="{ handleSubmit }">
                  <div class="card-body c-body p-40px">
                    <form @submit.prevent="handleSubmit(onSubmit)" class="d-flex">
                      <div class="col-lg-6" style>
                        <h4
                          class="inner-heading text-center pt-2 pb-1 w-100 mb-4"
                          style="font-weight: 400; margin-bottom:0px;"
                        >
                          <i class="fa fa-user mr-2" aria-hidden="true"></i> Activate Account
                        </h4>
                        <div class="mainform-holder w-100">
                          <div class="col-lg-12 mb-2">
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <ValidationProvider
                                  name="E-mail"
                                  rules="required|email"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model="email"
                                    type="email"
                                    class="form-control bg-grey"
                                    id="inputContactEmail"
                                    placeholder="Email"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12 mb-2">
                            <div class="form-group row">
                              <div class="col-sm-12">
                                <ValidationProvider
                                  name="Token"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <input
                                    v-model="token"
                                    type="text"
                                    class="form-control bg-grey"
                                    id="inputToken"
                                    placeholder="Token"
                                  />
                                  <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-12 mb-3">
                              <div class="form-group mb-0">
                                <div class="text-right" >
                                  <button
                                    type="submit"
                                    class="btn btn-primary black-btn color-white btn-block"
                                    style="padding: 6px 35px; border-radius:50px;"
                                  >Activate Account</button>
                                </div>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="form-group mb-0">
                                <div class="text-center">
                                  <a class @click="GotoSignin()" style="font-size: 14px;">Sign In</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </div>
      </div>
      <training-footer></training-footer>
    </div>
  </div>
</template>

<script>
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import ApiServices from "../service/ApiServices";
import trainingHeader from "../components/trainingHeader";
import trainingFooter from "../components/trainingFooter";

extend("required", {
  ...required,
  message: "This field is required"
});
export default {
  name: "activation",
  props: {},
  components: {
    trainingHeader,
    trainingFooter
  },
  data() {
    return {
      email: "",
      token: "",
      settings: settings
    };
  },
  methods: {
    onSubmit() {
      this.$root.loading = true;
      //let headers = {Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q='};
      ApiServices.RestGetCall("api/avenir/subscribe/authorize", {email: this.email, token: this.token}, "systemBasicAuth").then(response => {
        this.$root.loading = false;
        console.log(response);
        if (response.status.toLocaleLowerCase() == "success") {
          this.email = this.token = "";
          this.$swal({
            text: response.message
          }).then(() => {
            this.$router.push("/");
          });
        } else {
          this.$swal({
            text: response.message
          });
        }
      });
    },
    GotoSignin() {
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
